import React from "react"
import Cabecalho from "../Cabecalho"
import { TabelaHistoricoFechamentos } from "./components/TabelaHistoricoFechamentos"

export function HistoricoFechamentos() {
    return (
        <>
            <Cabecalho pagina="Histórico de Fechamentos" />
            <TabelaHistoricoFechamentos />
        </>
    )
}
